import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../shared/hooks/useAuth'

export function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isResetting, setIsResetting] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [message, setMessage] = useState<string | null>(null)

  const { signIn, resetPassword } = useAuth()
  const navigate = useNavigate()

  const handleSignIn = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    setMessage(null)

    if (!email || !password) {
      setError('Please enter both email and password.')
      return
    }

    const { error } = await signIn(email, password)
    if (error) {
      setError(error.message)
    } else {
      // Let auth listener fill role; send to portal as landing
      navigate('/portal')
    }
  }

  const handleResetPassword = async () => {
    setError(null)
    setMessage(null)

    if (!email) {
      setError('Enter your email first.')
      return
    }

    const { error } = await resetPassword(email)
    if (error) {
      setError(error.message)
    } else {
      setMessage('If that email exists, a reset link has been sent.')
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="glass-card w-full max-w-md p-8 text-center space-y-6">
        <h1 className="text-3xl font-semibold text-slate-900 mb-2">
          Employee Lab / IMA Portal
        </h1>
        <p className="text-sm text-slate-600 mb-6">Employee Lab access only.</p>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
            {error}
          </div>
        )}

        {message && (
          <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg text-sm">
            {message}
          </div>
        )}

        {!isResetting ? (
          <form onSubmit={handleSignIn} className="space-y-4">
            <input
              id="email"
              type="email"
              placeholder="Work email"
              className="form-input"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              id="password"
              type="password"
              placeholder="Password"
              className="form-input"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button type="submit" className="btn-orange w-full">
              Sign in
            </button>
            <button
              type="button"
              onClick={() => setIsResetting(true)}
              className="btn-secondary w-full"
            >
              Forgot password
            </button>
          </form>
        ) : (
          <div className="space-y-4">
            <input
              type="email"
              placeholder="Work email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button onClick={handleResetPassword} className="btn-orange w-full">
              Send reset link
            </button>
            <button
              onClick={() => setIsResetting(false)}
              className="btn-secondary w-full"
            >
              Back to sign in
            </button>
          </div>
        )}

        <p className="text-sm text-slate-600 mt-6">
          Public claim form (no login):{' '}
          <a
            href="https://www.employeelab.co.nz/nzrail-claims"
            className="underline text-nzrail-blue hover:text-nzrail-orange"
          >
            NZ Rail Claims
          </a>
        </p>
      </div>
    </div>
  )
}
